/**
 * The GPU map, loaded on demand (perf overhaul, Stage 2b): three.js and the scene host are their own chunk, fetched
 * only by a viewer with the canvas on (useMapGpu), so nobody else downloads or parses them. A chunk that fails to
 * load is the same as a browser without WebGL: `onUnavailable` is told and the svg keeps drawing the map.
 *
 * The lazy component is made per mount, not per module: React keeps a lazy's first outcome for good, so one at
 * module scope would turn one flaky fetch into a dead GPU path for the life of the page. A loaded chunk is cached by
 * the module loader either way, so a remount costs nothing.
 */
import { Suspense, lazy, useEffect, useState } from 'react';

function chunkFailed(err) {
  return function Unavailable({ onUnavailable }) {
    useEffect(() => onUnavailable(err), [onUnavailable]);
    return null;
  };
}

const loadScene = () => lazy(() => import('./GpuScene').catch((err) => ({ default: chunkFailed(err) })));

export default function GpuCanvas(props) {
  const [GpuScene] = useState(loadScene);
  return (
    <Suspense fallback={null}>
      <GpuScene {...props} />
    </Suspense>
  );
}
